// import React, { useContext, useEffect, useState } from "react";
// import "./Header.css";
// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from "react-bootstrap/NavDropdown";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { fas, faUser } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Context } from "../../utils/context";
// import { useNavigate } from "react-router";

// import Cookies from "js-cookie";
// import { Button, InputGroup, Offcanvas } from "react-bootstrap";
// import { Form } from "react-bootstrap";
// import { FaBars } from "react-icons/fa";
// import MobileSidebar from "../Sidebar/MobileSidebar";
// import ViewOffCanvance from "../myProfile/ViewOffCanvance";
// import Logoutmodal from "../common/Logoutmodal/Logoutmodal";
// import { Link } from "react-router-dom";
// import { RoleId } from "../../utils/common";
// import RangeModel from "../common/RangeModel";
// import Sidebar from "../Sidebar/Sidebar";
// import PasswordChange from "../common/password_change/PasswordChange";
// library.add(fas);
// // ({ title, link })
// function Header({ title, props }) {
//   const {
//     setUserData,
//     setUsertype,
//     setSignin,
//     usertype,
//     isSidebarOpen,
//     setSidebarOpen,
//     toggleSidebar,
//     getData,
//     IMG_URL,
//   } = useContext(Context);

//   const navigate = useNavigate();

//   const LogOut = async () => {
//     Cookies.remove("gurukrupa_admin_security", { path: "/" });
//     await setUserData("");
//     await setUsertype("");
//     await setSignin(false);
//     navigate("/");
//   };

//   const [user, setUser] = useState({});
//   const [store, setStore] = useState({});
//   const GetUserData = async () => {
//     const response = await getData(`/common/auth/usersingleget`);
//     if (response?.success) {
//       setUser(response?.data);
//       if (response?.data?.role_id === RoleId.Vendor) {
//         const res = await getData(`/admin/store/my-store`);
//         await setStore(res?.data);
//       }
//     }
//   };
//   useEffect(() => {
//     GetUserData();
//   }, []);

//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const [view, setView] = useState(false);
//   const [viewRangeModel, setViewRangeModel] = useState(false);
//   const handleViewClose = () => setView(false);
//   const handleViewshow = async () => {
//     await setView(true);
//   };

//   const [modalshow, setmodalshow] = useState(false);

//   const [password, setPassword] = useState(false);
//   const handleshow = async () => {
//     await setPassword(true);
//   };

//   const [appSetup, setAppSetup] = useState({});
//   const GetAppSetup = async () => {
//     const response = await getData(`/common/masters/app-setup`);
//     if (response?.success) {
//       setAppSetup(response?.data);
//     }
//   };

//   useEffect(() => {
//     GetAppSetup();
//   }, []);
//   return (
//     <>
//       <section className="header">
//         <Navbar expand="md" className="bg-body-tertiary">
//           <Navbar.Brand>
//             <div className="header-text">
//               <div className="desktop-bar-btnnn">
//                 <div className="bars d-flex" onClick={toggleSidebar}>
//                   <FaBars />
//                   <h1>{title}</h1>
//                 </div>
//               </div>

//               <div className="mobile-view-bar">
//                 <div className="bars" onClick={handleShow}>
//                   <FaBars />
//                 </div>
//                 <Offcanvas
//                   show={show}
//                   onHide={handleClose}
//                   backdrop="static"
//                   style={{ width: "80%" }}
//                 >
//                   <Offcanvas.Header closeButton>
//                     <Offcanvas.Title className="mobdshhide">
//                       DashBoard
//                     </Offcanvas.Title>
//                     <Link to="/advanceDashboard">
//                       <img
//                         className="moblogefwfgj"
//                         src={IMG_URL + appSetup?.logo}
//                       />
//                     </Link>
//                   </Offcanvas.Header>
//                   <Offcanvas.Body>
//                     {/* <MobileSidebar /> */}
//                     <Sidebar />
//                   </Offcanvas.Body>
//                 </Offcanvas>
//               </div>
//             </div>
//           </Navbar.Brand>
//           <Navbar.Toggle aria-controls="basic-navbar-nav" />

//           <div className="mobview_loglogo">
//             <div className="logodiv">
//               <img
//                 className="logo"
//                 src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
//               />
//             </div>
//           </div>

//           {/* <div className="mobview_loglogo">
//             <button className="btn btn-dark" onClick={handleshow}>
//               <FontAwesomeIcon
//                 icon="fa-solid fa-shield-halved"
//                 className="power-icon icon  me-3"
//               />
//               Change Password
//             </button>
//             <div className="icon dropdown" data-name="Logout">
//               <div
//                 className="text-center dropdown-toggle"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 <FontAwesomeIcon
//                   icon="fa-solid fa-power-off"
//                   className="power-icon"
//                 />
//               </div>

//               <ul className="dropdown-menu">
//                 <div className="blue-bg">
//                   <div className="text-center usericon">
//                     <FontAwesomeIcon className="floguser" icon={faUser} />
//                   </div>

//                   <div
//                     className="icon dropdown"
//                     style={{ textAlign: "center" }}
//                   >
//                     <p className="mb-0 logout_content_sec">
//                       {user?.first_name}
//                     </p>
//                     <p className="logout_content_secccc">{user?.type}</p>
//                   </div>
//                 </div>

//                 <li>
//                   <a className="dropdown-item" href="#">
//                     <button
//                       onClick={() => setmodalshow(true)}
//                       className="logout-btnnn"
//                     >
//                       {" "}
//                       Log out
//                     </button>
//                   </a>
//                 </li>
//               </ul>
//             </div>
//           </div> */}

//           <Navbar.Collapse id="basic-navbar-nav">
//             <Nav className="ms-auto d-flex ">
//               <div className="mobview_loglogo">
//                 <button className="btn btn-dark" onClick={handleshow}>
//                   <FontAwesomeIcon
//                     icon="fa-solid fa-shield-halved"
//                     className="power-icon icon  me-3"
//                   />
//                   Change Password
//                 </button>
//                 <div className="icon dropdown" data-name="Logout">
//                   <div
//                     className="text-center dropdown-toggle"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     <FontAwesomeIcon
//                       icon="fa-solid fa-power-off"
//                       className="power-icon"
//                     />
//                   </div>

//                   <ul className="dropdown-menu">
//                     <div className="blue-bg">
//                       <div className="text-center usericon">
//                         <FontAwesomeIcon className="floguser" icon={faUser} />
//                       </div>

//                       <div
//                         className="icon dropdown"
//                         style={{ textAlign: "center" }}
//                       >
//                         <p className="mb-0 logout_content_sec">
//                           {user?.first_name}
//                         </p>
//                         <p className="logout_content_secccc">{user?.type}</p>
//                       </div>
//                     </div>

//                     <li>
//                       <a className="dropdown-item" href="#">
//                         <button
//                           onClick={() => setmodalshow(true)}
//                           className="logout-btnnn"
//                         >
//                           {" "}
//                           Log out
//                         </button>
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <div className="header-icons">
//                 {user?.role_id === RoleId.Vendor && (
//                   <>
//                     <div className="search-area icon" data-name="QR Code">
//                       <Link
//                         to={IMG_URL + "/" + store?.qr_code}
//                         target="_blank"
//                         download={IMG_URL + "/" + store?.qr_code}
//                         rel="noopener noreferrer"
//                       >
//                         <FontAwesomeIcon
//                           icon={["fas", "qrcode"]} // or use `icon="qrcode"` if set up globally
//                           className="power-icon"
//                         />
//                       </Link>
//                     </div>
//                     <div className="search-area icon" data-name="Profile">
//                       <Link to="/profile">
//                         <FontAwesomeIcon
//                           icon="fa-solid fa-user"
//                           className="power-icon"
//                         />
//                       </Link>
//                     </div>
//                     <div className="search-area icon" data-name="Wallet">
//                       <Link to="/my-wallet">
//                         <FontAwesomeIcon
//                           icon="fa-solid fa-wallet"
//                           className="power-icon"
//                         />
//                       </Link>
//                     </div>
//                   </>
//                 )}

//                 <div className="icon dropdown" data-name="Logout">
//                   <div
//                     className="text-center dropdown-toggle"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     <FontAwesomeIcon
//                       icon="fa-solid fa-power-off"
//                       className="power-icon"
//                     />
//                   </div>

//                   <ul className="dropdown-menu">
//                     <div className="blue-bg usericon">
//                       <div className="text-center">
//                         <FontAwesomeIcon className="floguser" icon={faUser} />
//                       </div>

//                       <div
//                         className="icon dropdown"
//                         style={{ textAlign: "center" }}
//                       >
//                         <p className="mb-0 logout_content_sec">
//                           {user?.first_name}
//                         </p>
//                         <p className="logout_content_secccc">{user?.type}</p>
//                       </div>
//                     </div>

//                     <li>
//                       <a className="dropdown-item logout_btn_a" href="#">
//                         <button
//                           onClick={() => setmodalshow(true)}
//                           className="logout-btnnn"
//                         >
//                           {" "}
//                           Log out
//                         </button>
//                       </a>
//                     </li>
//                   </ul>
//                 </div>

//                 <p className="mb-0 logout_content">{user?.name}</p>
//               </div>
//             </Nav>
//           </Navbar.Collapse>
//         </Navbar>

//         <Logoutmodal
//           show={modalshow}
//           onHide={() => setmodalshow(false)}
//           LogOut={LogOut}
//         />
//       </section>
//       {view ? (
//         <ViewOffCanvance
//           handleClose={handleViewClose}
//           setShow={setView}
//           show={view}
//           user_id={user?.id}
//         />
//       ) : (
//         ""
//       )}

//       {viewRangeModel ? (
//         <RangeModel
//           handleClose={() => {
//             setViewRangeModel(false);
//             GetUserData();
//           }}
//           setShow={setViewRangeModel}
//           show={viewRangeModel}
//           user_id={user?.id}
//           store={store}
//         />
//       ) : (
//         ""
//       )}

//       {password ? (
//         <PasswordChange
//           handleClose={handleClose}
//           setShow={setPassword}
//           show={password}
//           user_id={user?.id}
//           onHide={() => setPassword(false)}
//         />
//       ) : (
//         ""
//       )}
//     </>
//   );
// }

// export default Header;

import React, { useContext, useEffect, useState } from "react";
import "./Header.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  fas,
  faUser,
  faShieldHalved,
  faPowerOff,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../utils/context";
import { useNavigate } from "react-router";

import Cookies from "js-cookie";
import { Offcanvas } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import ViewOffCanvance from "../myProfile/ViewOffCanvance";
import Logoutmodal from "../common/Logoutmodal/Logoutmodal";
import { Link } from "react-router-dom";
import { RoleId } from "../../utils/common";
import RangeModel from "../common/RangeModel";
import Sidebar from "../Sidebar/Sidebar";
import PasswordChange from "../common/password_change/PasswordChange";

library.add(fas);

function Header({ title, props }) {
  const {
    setUserData,
    setUsertype,
    setSignin,
    usertype,
    isSidebarOpen,
    setSidebarOpen,
    toggleSidebar,
    getData,
    IMG_URL,
  } = useContext(Context);

  const navigate = useNavigate();

  const LogOut = async () => {
    Cookies.remove("gurukrupa_admin_security", { path: "/" });
    await setUserData("");
    await setUsertype("");
    await setSignin(false);
    navigate("/");
  };

  const [user, setUser] = useState({});
  const [store, setStore] = useState({});

  const GetUserData = async () => {
    const response = await getData(`/common/auth/usersingleget`);

    if (response?.success) {
      setUser(response?.data);

      if (response?.data?.role_id === RoleId.Vendor) {
        const res = await getData(`/admin/store/my-store`);
        await setStore(res?.data);
      }
    }
  };

  useEffect(() => {
    GetUserData();
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [view, setView] = useState(false);
  const [viewRangeModel, setViewRangeModel] = useState(false);

  const handleViewClose = () => setView(false);

  const handleViewshow = async () => {
    await setView(true);
  };

  const [modalshow, setmodalshow] = useState(false);

  const [password, setPassword] = useState(false);

  const handleshow = async () => {
    await setPassword(true);
  };

  const [appSetup, setAppSetup] = useState({});

  const GetAppSetup = async () => {
    const response = await getData(`/common/masters/app-setup`);

    if (response?.success) {
      setAppSetup(response?.data);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  return (
    <>
      <section className="header">
        <Navbar expand="md">
          <Navbar.Brand>
            <div className="header-text">
              <div className="desktop-bar-btnnn">
                <div className="bars" onClick={toggleSidebar}>
                  <FaBars />
                  <h1>{title}</h1>
                </div>
              </div>

              <div className="mobile-view-bar">
                <div className="bars" onClick={handleShow}>
                  <FaBars />
                </div>

                <Offcanvas
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  style={{ width: "80%" }}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="mobdshhide">
                      DashBoard
                    </Offcanvas.Title>

                    <Link to="/advanceDashboard">
                      <img
                        className="moblogefwfgj"
                        src={IMG_URL + appSetup?.logo}
                      />
                    </Link>
                  </Offcanvas.Header>

                  <Offcanvas.Body>
                    <Sidebar />
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            </div>
          </Navbar.Brand>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto d-flex">
              <div className="header-icons">
                {user?.role_id === RoleId.Vendor && (
                  <>
                    <div className="search-area icon" data-name="QR Code">
                      <Link
                        to={IMG_URL + "/" + store?.qr_code}
                        target="_blank"
                        download={IMG_URL + "/" + store?.qr_code}
                        rel="noopener noreferrer"
                      >
                        <FontAwesomeIcon
                          icon={["fas", "qrcode"]}
                          className="power-icon"
                        />
                      </Link>
                    </div>

                    <div className="search-area icon" data-name="Profile">
                      <Link to="/profile">
                        <FontAwesomeIcon
                          icon="fa-solid fa-user"
                          className="power-icon"
                        />
                      </Link>
                    </div>

                    <div className="search-area icon" data-name="Wallet">
                      <Link to="/my-wallet">
                        <FontAwesomeIcon
                          icon="fa-solid fa-wallet"
                          className="power-icon"
                        />
                      </Link>
                    </div>
                  </>
                )}

                <button
                  type="button"
                  className="change-password-btn"
                  onClick={handleshow}
                >
                  <FontAwesomeIcon icon={faShieldHalved} />
                  <span>Change Password</span>
                </button>

                <div
                  className="icon dropdown logout-dropdown"
                  data-name="Logout"
                >
                  <div
                    className="text-center dropdown-toggle logout-icon-btn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faPowerOff} className="power-icon" />
                  </div>

                  <ul className="dropdown-menu">
                    <div className="blue-bg">
                      <div className="usericon">
                        <FontAwesomeIcon className="floguser" icon={faUser} />
                      </div>

                      <div className="user-details">
                        <p className="logout_content_sec">{user?.first_name}</p>

                        <p className="logout_content_secccc">{user?.type}</p>
                      </div>
                    </div>

                    <li>
                      <div className="dropdown-item logout_btn_a">
                        <button
                          type="button"
                          onClick={() => setmodalshow(true)}
                          className="logout-btnnn"
                        >
                          Log out
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>

                <p className="mb-0 logout_content">{user?.name}</p>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Logoutmodal
          show={modalshow}
          onHide={() => setmodalshow(false)}
          LogOut={LogOut}
        />
      </section>

      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setView}
          show={view}
          user_id={user?.id}
        />
      ) : (
        ""
      )}

      {viewRangeModel ? (
        <RangeModel
          handleClose={() => {
            setViewRangeModel(false);
            GetUserData();
          }}
          setShow={setViewRangeModel}
          show={viewRangeModel}
          user_id={user?.id}
          store={store}
        />
      ) : (
        ""
      )}

      {password ? (
        <PasswordChange
          handleClose={() => setPassword(false)}
          setShow={setPassword}
          show={password}
          user_id={user?.id}
          onHide={() => setPassword(false)}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Header;
